<template lang="pug">
  b-field(:type="{'is-danger': error(input_name, errors)}"
          :message="errorMessageFor(input_name, errors)" id="wide-autocomplete")
    b-autocomplete(data-vv-as="isbn"
      :name="input_name"
      size="is-small"
      v-model="internalValue"
      :disabled="disabled"
      :loading="loading"
      :data="filteredDataObj"
      field="isbn"
      open-on-focus
      class="fully-visible-autocomplete"
      @blur="setIsbn()"
    )
      template(slot-scope="props")
        span {{ displayOption(props.option.isbn, props.option.name) }}
    | {{ bookName }}

</template>

<script>
  import ErrorDisplayer from 'mixins/error_displayer'

  export default {
    name: 'isbn-input',
    mixins: [ErrorDisplayer],
    data() {
      return {
      }
    },
    props: {
      input_name: {
        type: String,
        required: true
      },
      value: {
        type: String,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      books: {
        type: Array,
        required: true,
        default: []
      },
      errors: {
        required: false
      }
    },
    computed: {
      loading(){
        return 0 == this.books.length
      },
      internalValue: {
        get() {
          return this.value
        },
        set(newVal) {
          if (this.value !== newVal) this.$emit('input', newVal)
        }
      },
      bookName(){
        var a = this.filteredDataObj
        if(a.length == 1){
          return a[0].name
        }else{
          return ""
        }
      },
      filteredDataObj() {
        let isProductCode = this.internalValue && this.internalValue.slice(0,1) == '/'
        return this.books.filter((book) => {
          return(
            isProductCode ?
              `/${book.product_code}`.indexOf(this.internalValue) >= 0
              : `${book.isbn} ${book.name} ${book.author}`.indexOf(this.internalValue) >= 0
          )
        })
      }
    },
    methods: {
      setIsbn() {
        if(!this.internalValue || this.internalValue.length == 13)
          return
        const book = this.books.find(book => book.isbn == this.internalValue || `/${book.product_code}` == this.internalValue)
        if(book)
          this.internalValue = book.isbn
      },
      displayOption(isbn, name) {
        return isbn + ' ' + name
      }
    },
    created() {
    },
    mounted() {
      this.setIsbn()
    }
  }
</script>
